export const ClaimButton = (props) => {
  const { onClaim, disabled } = props;

  return (
    <div className="flex items-center">
      <button
        type="button"
        className={`ml-auto border border-[#FFD700] text-[#FFD700] px-[8px] h-[22px] flex items-center justify-center rounded-[4px] cursor-pointer hover:bg-[#FFD700]/10 transition-colors ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        onClick={() => {
          if (!disabled) {
            onClaim();
          }
        }}
        disabled={disabled}
      >
        {disabled ? 'Claiming...' : 'Claim'}
      </button>
    </div>
  );
};